var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program-list"},[_c('h2',[_vm._v(_vm._s(_vm.$t("reservation.availablePrograms")))]),_c('ProgramList',{attrs:{"programs":_vm.programs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }